module.exports = {
    "id": "zuzo-maze",
    "title": "Zuzo's Maze",
    "character-image": "/provision/projects/zuzo-maze/zuzo.png",

    "project_file": "zuzo-maze.gbp",
    "thumbnail": "/provision/projects/zuzo-maze/zuzo-maze.png",
    "category": "games",
    "toolbar":{
      "glitches":[],
      "parts":[]
    }
  }
  ;